import React from "react";
import { HelpScoutUrls } from "../../utils/helpScoutUrls";
import { ColorClassNames } from "../../Colors";
import { LegalDisclaimer, LegalDisclaimerPropsWithoutContent } from "../LegalDisclaimer";

const content = (
  <span>
    By logging in, I agree to the{" "}
    <a
      className={`${ColorClassNames.mint} bold`}
      href={HelpScoutUrls.termsOfService}
      rel="noopener noreferrer"
      target="_blank"
    >
      Terms of Service
    </a>{" "}
    and{" "}
    <a
      className={`${ColorClassNames.mint} bold`}
      href={HelpScoutUrls.privacyPolicy}
      rel="noopener noreferrer"
      target="_blank"
    >
      Privacy Policy.
    </a>
  </span>
);

export default function DisclaimerAgreeToTermsOfServiceLogin(props: LegalDisclaimerPropsWithoutContent) {
  return <LegalDisclaimer {...props} content={content} />;
}
